import { useEffect, useState } from "react";
import "../styles/updateTournament.css"; // ✅ reuse same css
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "./hmac";

const DeleteTournament = () => {
  const [tournaments, setTournaments] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const fetchTournaments = async () => {
    try {
      const { host, fetchTournaments, basic } = API_CONFIG;
      const urn = generateURN();
      const authToken = generateAuthToken(urn);

      setLoading(true);
      setMsg("");

      const res = await fetch(`https://${host}${fetchTournaments.path}`, {
        method: fetchTournaments.method,
        credentials: "include",
        headers: {
          Authorization: `Basic ${basic.BASIC_AUTH_CWUSER}`,
          urn,
          authToken,
        },
      });

      const data = await res.json();
      const list = data?.apiResponseData?.responseData?.tournaments || [];
      setTournaments(list);
    } catch (err) {
      setMsg("Failed to fetch tournaments: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTournaments();
  }, []);

  const handleSelect = (t) => {
    setSelected(t);
    setMsg("");
  };

  const closePopup = () => setSelected(null);

  const deleteTournament = async () => {
    if (!selected?.tournamentID) return;

    try {
      const { host, deleteTournament, basic } = API_CONFIG;
      const urn = generateURN();
      const authToken = generateAuthToken(urn,"admin");

      setLoading(true);
      setMsg("");

      const url = `https://${host}${deleteTournament.path(selected.tournamentID)}`;

      const res = await fetch(url, {
        method: deleteTournament.method,
        credentials: "include",
        headers: {
          Authorization: `Basic ${basic.BASIC_AUTH_ADMIN}`,
          urn,
          authToken,
        },
      });

      const data = await res.json();

      if (!res.ok || data?.responseCode === 0) {
        setMsg(" Delete failed.");
        return;
      }

      setMsg(" Tournament deleted successfully.");
      sessionStorage.clear();
      await fetchTournaments();
      closePopup();
    } catch (err) {
      setMsg(" Something went wrong: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update-tournament-container">
      <h2 className="update-title">Delete Tournament</h2>

      {loading && <p className="info-text">Loading...</p>}
      {msg && <p className="info-text">{msg}</p>}

      <div className="tournament-grid">
        {tournaments.map((t) => (
          <div
            key={t.tournamentID}
            className="tournament-card"
            onClick={() => handleSelect(t)}
          >
            <div className="t-card-top">
              <h3 className="t-card-title">{t.tournamentName}</h3>

              <span
                className={`status-badge ${
                  t.tournamentStatus === 1 ? "on" : "off"
                }`}
              >
                {t.tournamentStatus === 1 ? "ACTIVE" : "INACTIVE"}
              </span>
            </div>

            <p className="t-card-date">{t.date}</p>
          </div>
        ))}
      </div>

      {selected && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">{selected.tournamentName}</h3>
            <p className="popup-date">{selected.date}</p>

            <p className="popup-status">
              Status:{" "}
              <b>{selected.tournamentStatus === 1 ? "ACTIVE " : "INACTIVE "}</b>
            </p>

            <p className="popup-status">
              ⚠️ This action cannot be undone.
            </p>

            <div className="popup-actions">
              {/* ✅ using SAME button styles */}
              <button
                className="btn-inactive"
                disabled={loading}
                onClick={deleteTournament}
              >
                Delete Tournament
              </button>

              <button
                className="btn-active"
                disabled={loading}
                onClick={closePopup}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteTournament;
